$(document).ready(function() {   
    
    // Stock Slider - Home Slider
    $('.banner').each(function(){
        var scope = $(this);
        $(this).imagesLoaded(function(){
            
            var stockItems = $('.slideSet').children('.slide').clone();

            scope.find('.slideSet').flickity({
                cellAlign: 'right',
                groupCells: '100%',
                autoPlay: 7000,
                pageDots: true,
                prevNextButtons: true,
            });            
        });
    });


    // Clients Logo Slider - HomePage
    $('.client-logo').each(function(){
        var scope = $(this);
        $(this).imagesLoaded(function(){
            
            var stockItems = $('.logoGrid').children('.logo-item').clone();
            
            var draggable = false;
            var prevNextButtons = false;
            if ( matchMedia('screen and (max-width: 992px)').matches ) {
              draggable = true;
              prevNextButtons = true;
            }

            scope.find('.logoGrid').flickity({                
                initialIndex: 1,
                contain: true,
                cellAlign: 'left',                
                wrapAround: true, 
                draggable: draggable,
                groupCells: true,
                pageDots: false,
                prevNextButtons: prevNextButtons,
            });

        });
    });

    // Stock Slider - Project Slider
    $('.project-slider').each(function(){
        var scope = $(this);
        $(this).imagesLoaded(function(){
            
            var stockItems = $('.proslideSet').children('.proSlide').clone();

            scope.find('.proslideSet').flickity({
                cellAlign: 'right',
                groupCells: '100%',
                autoPlay: 7000,
                pageDots: true,
                prevNextButtons: true,
            });            
        });
    });

    // Stock Slider - Project Slider
    $('.box-slider').each(function(){
        var scope = $(this);
        $(this).imagesLoaded(function(){
            
            var stockItems = $('.boxslideSet').children('.boxSlide').clone();

            scope.find('.boxslideSet').flickity({
                cellAlign: 'right',
                groupCells: '100%',
                autoPlay: 7000,
                pageDots: true,
                prevNextButtons: true,
            });            
        });
    });


    // Stock Slider - Home Slider
    $('.single-slider').each(function(){
        var scope = $(this);
        $(this).imagesLoaded(function(){
            
            var stockItems = $('.single-row').children('.single-cell').clone();

            scope.find('.single-row').flickity({
                autoPlay: 7000, 
                wrapAround: true,               
                groupCells: true,
                cellAlign: 'center',
                pageDots: true,
                prevNextButtons: true,
            });            
        });
    });

    // Stock Slider - Multiple Product Slider
    $('.group-slider').each(function(){
        var scope = $(this);
        $(this).imagesLoaded(function(){
            
            var stockItems = $('.sliderRow').children('.slider-cell').clone();

            scope.find('.sliderRow').flickity({
                autoPlay: 7000, 
                groupCells: true,
                cellAlign: 'center',
                pageDots: true,
                prevNextButtons: true,
                wrapAround: true,
            });            
        });
    });

    // Thumbnail Slider - LED Product Details Page
    $('.thumbnailSlider').each(function(){
        var scope = $(this);

        // 1st carousel, main
        $('.larg-slider').flickity({
            pageDots: false,
            prevNextButtons: false,
            imagesLoaded: true,
        });

        // 2nd carousel, navigation
        $('.larg-slider-nav').flickity({
            asNavFor: '.larg-slider',
            contain: true,
            pageDots: false,
            prevNextButtons: false,
        });
    });

    // Fancybox Slider - Product Details Page
    $('[data-fancybox]').fancybox({
      loop : false,
      keyboard : true,
      arrows : true,      
      toolbar : true,
      protect : true,
      animationEffect : "zoom",     
      
      buttons : [        
        'close'
        ],
    });
});


